(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-sale-cards"]) return;
  try {
    
document.querySelectorAll('.shop-items-azaadi > li[data-product-url]').forEach(function (item) {
  item.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a, button, input, label, select, textarea')) return;
    var url = item.getAttribute('data-product-url');
    if (!url) return;
    window.location.href = window.location.origin + url;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-page-sec-2025"] && !Shopify.designMode) return;
  try {
    

 

document.querySelectorAll('.shop-items-azaadi>li').forEach(function(item) {
  item.addEventListener('click', function() {
    var prodLink = item.getAttribute('data-product-url');
    console.log(prodLink);
    window.location.href = "https://zerolifestyle.co" + prodLink;
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-page-section"] && !Shopify.designMode) return;
  try {
    

 

document.querySelectorAll('.shop-items-azaadi>li').forEach(function(item) {
  item.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('a')) return;
    var prodLink = item.getAttribute('data-product-url');
    if (!prodLink) return;
    window.location.href = "https://zerolifestyle.co" + prodLink;
  });
});


  } catch(e) { console.error(e); }
})();
})();
